import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {CustomizeHttpUrlGenerator} from "../../../../store/core/url/customizeHttpUrlGenerator";
import {AbstractActionService} from "../../../core/service/v2/service/action/abstractAction.service";
import {PayloadWithId} from "../../../core/service/payload/payloadWithId";
import {SaleSavePayloadProduct} from "./payload/save/saleSavePayloadProduct.payload";
import {SaleProductSummaryModel} from "../../modules/product/api/entity/saleProductSummary.model";
import {SaleProductSummaryConverter} from "../../modules/product/api/converter/saleProductSummary.converter";

@Injectable()
export class SaleAddSaleProductActionService extends AbstractActionService<SaleUpdateSaleProductActionPayload, SaleProductSummaryModel> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient,
                       private converter: SaleProductSummaryConverter) {
        super('Sale', 'add-sale-product', customizeHttpUrlGenerator, httpClient);
    }

    protected buildResponse(response: any): SaleProductSummaryModel {
        return this.converter.convert(response);
    }
}

export class SaleUpdateSaleProductActionPayload extends PayloadWithId {
    saleProduct: SaleSavePayloadProduct;
}